/**
* this displays the fund overview
*
* Created by Paul on 27/05/19
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import NumberFormat from 'react-number-format'
import moment from 'moment'

// action import
import { ActionCreator } from '../../actions/'

// Configurations
import constants from '../../constants'
import config from '../../config'
import { intlNumberFormatter, substitute } from '../../utility/utilities'

// material-ui import
import { withStyles, makeStyles } from '@material-ui/styles';
import { createMuiTheme } from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid'

import BillingTable from '../../components/BillingTable/'

const styles = theme => ({
    gridroot: {
        flexGrow: 1,
    },
    card: {
        height: '100%',
    },
    title: {
        fontSize: 16,
    },
    pos: {
        marginBottom: 12,
    },
    card_body: {
        fontSize: 13,
    },
})

class FundBilling extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        const { member_id, getBillingData } = this.props
        getBillingData(member_id)
    }

    getBillingDownloadURL(id){
        const invoiceDowload = substitute(config.endpoints.billingDownloadURL, {id: id})
        return invoiceDowload;
    }

    render() {

        const { billingData, billingloading, member_id } = this.props
        
        return (
            
            <ExpansionPanelDetails>

                <BillingTable billingData={billingData} billingloading={billingloading} member_id={member_id} />
                        
            </ExpansionPanelDetails>
        )
    }
}

// define the prop types
FundBilling.propTypes = {
    classes: PropTypes.object.isRequired,
    billingData: PropTypes.array,
}

const mapStateToPros = (state) => {
    return {
        billingData: state.billingState.data,
        billingloading : state.billingState.billingloading,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getBillingData: action.getBillingData,
    }
}

export default connect(mapStateToPros,mapDispatchToProps)(withStyles(styles)(FundBilling))


// WEBPACK FOOTER //
// ./src/components/FundBilling/index.js